import React from "react";
import { Progress, InfiniteScroll, Button, dialog } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import { SubmitFormBaseList } from "../../../../components/common/Converter";
// import NavBarSearch from "../../../../components/NavBar/NavBarSearch";
import InputSearch from "../../../../components/InputSearch/InputSearch";
import SpecialAwardPresenter from "./SpecialAwardPresenter";

class RecipientLogPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new SpecialAwardPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      titles: [],
      filteredStatus: "",
      filteredTitle: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const titles = await findObjectUseCase().execute("recipient_log");
    this.setState({ titles });
  }

  async titleFilter(filteredTitle) {
    this.setState({ filteredTitle });
    this.onChangeFilter("String", filteredTitle, "title");
  }
  statusFilter(filteredStatus) {
    this.setState({ filteredStatus });
    this.onChangeFilter("String", filteredStatus, "stats");
  }

  getCollectionName() {
    return "recipient_log";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async handlePrintData(object) {
    // if (

    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row" style={{ textAlign: "center" }}>
            <p>
              <i
                className="bi bi-question-circle"
                style={{ color: "orange", fontSize: "20px" }}
              ></i>{" "}
              Confirm
            </p>
            <p
              style={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, .65)",
              }}
            >
              Please click on OK to confirm changes.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-3 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => {
                object.employee = { id: object.employee.id };
                object.stats = "Awarded";
                this.submitAwarded(object);
              }}
            >
              OK
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  async submitAwarded(update) {
    console.log("UPDATE: ", update);

    try {
      await upsertUseCase().execute("recipient_log", update);
      dialog.close();
      this.refetchData();
      this.showSuccess("Awarded");
    } catch (e) {
      console.error("Error: ", e);
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, titles, current, count, limit } = this.state;
    // const empPointer = objects
    //   .filter((item) => typeof item.employee === "object")
    //   .map((item) => item.employee);
    const uniqueTitle = [...new Set(titles.map((data) => data.title))];
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll loadMore={this.loadMore.bind(this)}>
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-block">
                  <h4 className="text-primary">{schema.label}</h4>
                  <div className="d-flex gap-2">
                    <SearchSelect
                      value={this.state.filteredStatus}
                      placeholder="Filter by Status"
                      onChange={this.statusFilter.bind(this)}
                      onClickClear={() => this.statusFilter("")}
                      options={[
                        ...["Pending", "Awarded"].map((stats) => ({
                          label: stats,
                          value: stats,
                        })),
                      ]}
                    />

                    <InputSearch
                      className="my-search"
                      onSubmit={this.titleFilter.bind(this)}
                      dropdownOptions={uniqueTitle}
                      placeholder="Search Title"
                    />

                    {/* <SearchSelect
                      value={
                        this.state.filteredTitle || "Filter by Special Award"
                      }
                      onChange={this.titleFilter.bind(this)}
                      onClickClear={() => this.titleFilter("")}
                      options={[
                        {
                          label: "Filter by Special Award",
                          value: "",
                        },
                        ...uniqueTitle.map((title) => ({
                          label: title,
                          value: title,
                        })),
                      ]}
                    /> */}
                  </div>
                </div>
              </CardView>

              <Table
                // empPointer={empPointer}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectData={this.handlePrintData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-award"> Awarded</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "description",
                    "qulification",
                    "count",
                  ],
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(RecipientLogPage);
